import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Typography,
} from "@mui/material";
import { Notifications as NotificationsIcon } from "@mui/icons-material";
import { useState } from "react";
import { RTL } from "../../cache/CacheRtl";
import { useAdminMessages } from "../../contexts/AdminMessageContext";
import { useMessageContext } from "../../contexts/MessageContext";
import { borders, colors, shadows } from "../ui/colors";
import moment from "moment";
import "moment/locale/he";

moment.locale("he");

const NewMessageDialog = () => {
  const { nextUnacknowledged, acknowledge } = useAdminMessages();
  const { notificationHandler } = useMessageContext();
  const [submitting, setSubmitting] = useState(false);

  const open = Boolean(nextUnacknowledged);

  const handleAcknowledge = () => {
    if (!nextUnacknowledged) return;
    setSubmitting(true);
    acknowledge(nextUnacknowledged.id)
      .catch(() => notificationHandler.error("פעולה נכשלה, נסה שוב"))
      .finally(() => setSubmitting(false));
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason === "backdropClick") return;
      }}
      PaperProps={{
        sx: {
          borderRadius: borders.radius.xl,
          minWidth: { xs: "92%", md: "480px" },
          maxWidth: { xs: "92%", md: "560px" },
          padding: 0,
          boxShadow: shadows.lg,
        },
      }}
    >
      <RTL>
        <Box dir="rtl">
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            p: 2.5,
            borderBottom: borders.default,
            backgroundColor: colors.primarySubtle,
          }}>
            <Box sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundColor: colors.primary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <NotificationsIcon sx={{ color: colors.white, fontSize: 22 }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: "12px", color: colors.textMuted, fontWeight: 600 }}>
                הודעה חדשה
              </Typography>
              <Typography sx={{ fontSize: "16px", fontWeight: 700, color: colors.textPrimary }}>
                {nextUnacknowledged?.message?.title}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ p: 2.5 }}>
            <Typography sx={{
              fontSize: "14px",
              color: colors.textSecondary,
              whiteSpace: "pre-wrap",
              lineHeight: 1.7,
            }}>
              {nextUnacknowledged?.message?.content}
            </Typography>
            <Typography sx={{ fontSize: "12px", color: colors.textMuted, mt: 2 }}>
              {nextUnacknowledged?.message?.senderName} · {nextUnacknowledged?.message?.createdDate ? moment.unix(nextUnacknowledged.message.createdDate).fromNow() : ""}
            </Typography>
          </Box>

          <Box sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
            borderTop: borders.default,
            backgroundColor: colors.bg,
          }}>
            <Button
              variant="contained"
              onClick={handleAcknowledge}
              disabled={submitting}
              sx={{
                backgroundColor: colors.primary,
                "&:hover": { backgroundColor: colors.primaryDark },
                borderRadius: borders.radius.md,
                textTransform: "none",
                fontWeight: 600,
                minWidth: "140px",
              }}
            >
              {submitting ? <CircularProgress size={20} sx={{ color: "white" }} /> : "אישור קריאה"}
            </Button>
          </Box>
        </Box>
      </RTL>
    </Dialog>
  );
};

export default NewMessageDialog;
